import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Avatar, Box, Button, InputAdornment, Typography } from '@mui/material';
import { PersonIcon } from 'components/common/IconCommon';
import TextFieldVMP from 'components/common/TextField/TextFieldVMP';
import { PATH_ROOT } from 'constants/api';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function RegisterEmailSameSSO({username, emailAccount, imageSource, name, onClickSubmit}) {
    const navigate = useNavigate();
    const {t} = useTranslation();

    return (
        <>
            <Typography fontSize={28} mb={3} fontWeight={600} textAlign={'center'}>{t('dialog.create-account-same-sso.title')}</Typography>
            <div className="body-create-account">
                <Typography mb={4}>
                    {t('dialog.create-account-same-sso.intro')}
                </Typography>
                <div className="avatar-account">
                    <Avatar className="avatar-account-image" variant="rounded" src={imageSource}>
                        {username?.slice(0, 1)?.toUpperCase()}
                    </Avatar>
                    <Box pl={1.25}>   
                        <Typography fontSize={18} fontWeight={700}>{name}</Typography>
                        <Typography sx={{ wordBreak: 'break-all' }}>{emailAccount}</Typography>
                    </Box>
                </div>
                <div className="username-account">
                    <Typography mb={1.5}>{t('dialog.create-account-same-sso.title-account')}</Typography>
                    <TextFieldVMP
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start" >
                                    <PersonIcon sx={{ color: '#949595'}} />
                                </InputAdornment>
                            ),
                        }}
                        value={username}
                        disabled
                    />
                </div>
                <div className="create-account-information">
                    <ErrorOutlineIcon sx={{ color: '#44494D', width: '20px'}} />
                    <Typography ml={0.5}>{t('dialog.create-account-same-sso.warning-content')}</Typography>
                </div>
                <div className="create-account-button">
                    <Button
                        size="large"
                        type={'submit'}
                        variant="contained"
                        sx={{ mb: 2, mt: 3}}
                        onClick={onClickSubmit}
                        fullWidth
                    >
                        {t('dialog.create-account-same-sso.link')}
                    </Button>
                    <Box>
                        <Typography>{t('dialog.create-account-same-sso.has-account')}</Typography>
                        <Typography sx={{ textDecoration: 'underline', cursor: 'pointer', color: theme => theme.palette.primary.main }} tabIndex={0} onKeyDown={(e) => {if(e.key === "Enter"){navigate(`${PATH_ROOT}/auth/login`)}}} onClick={() => {navigate(`${PATH_ROOT}/auth/login`)}}>{t('dialog.create-account-same-sso.login')}</Typography>
                    </Box>
                </div>
            </div>
        </>
    );
}
